import { SweetAlertService } from 'app/main/services/sweet-alert/sweet-alert.service';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { RoleService } from 'app/main/services/roles/role.service';
import { fuseAnimations } from 'app/core/animations';
import { Role } from 'app/main/models/roles/role';
import { PermissionService } from 'app/main/services/permissions/permission.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Permission } from 'app/main/models/permissions/permission';
import { FormControl, Validators } from '@angular/forms';
import { TranslationService } from 'app/main/services/translation/translation.service';

@Component({
    selector: 'fuse-add-role',
    templateUrl: './add-role.component.html',
    styleUrls: ['./add-role.component.scss'],
    animations: fuseAnimations
})
export class FuseAddRoleComponent implements OnInit {

    nameFormControl = new FormControl('', [
        Validators.required
    ]);  

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseAddRoleComponent>,
        private roleService: RoleService,
        private permissionService: PermissionService,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService
    ) {
        console.log('FuseAddRoleComponent > data', data);
    }

    ngOnInit() {
        
    }

    checkToggle(role: Role) {
        // console.log('FuseRolesAndPermissionsComponent > checkToggle > role', role);
        role.IsAllPermissionsChecked = !role.IsAllPermissionsChecked;
        for (const permission of role.Permissions) {
            if (permission.Name != 'PAGES_HOME') {
                permission.IsGranted = role.IsAllPermissionsChecked;
            }
        }
    }

    checkIfIsAllPermissionsChecked(role: Role, permission: Permission) {
        let permission2 = role.Permissions.find(p => p.Id == permission.Id);
        permission2.IsGranted = !permission2.IsGranted;
        let isAllPermissionsChecked = true;
        for (const permission of role.Permissions) {
            if (!permission.IsGranted) {
                isAllPermissionsChecked = false;
                break;
            }
        }
        role.IsAllPermissionsChecked = isAllPermissionsChecked;
    }

    addRole() {
        let permissionIds = [];
        for (const permission of this.data.role.Permissions) {
            if (permission.IsGranted) {
                permissionIds.push(permission.Id);
            }
        }
        this.roleService.add(this.data.role.Name, this.data.role.Description, permissionIds).subscribe(response => {
            if (response.ResultCode == 1) {
                this.data.role.Id = response.ApplicationRoleId;
                this.dialogRef.close(this.data.role);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.role, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                })
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/security/roles-and-permissions/components/add-role/add-role.component.ts